import OapMarquee from './code/Scripts/components/OapMarquee.vue';

export default {
  components: {
    OapMarquee,
  },
};
